export const LIST = "EVENT_BET_LIST";
export const OPTION_DATA = "EVENT_BET_OPTION_DATA";